import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { setUser } from "../redux/actions";

const AuthHandler = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isThirdStep, setIsThirdStep] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        if (user.emailVerified) {
          const userDetails = {
            uid: user.uid,
            email: user.email,
            name: user.displayName,
          };
          console.log("[AuthHandler] setUser details:", userDetails);
          dispatch(setUser(userDetails));
          navigate("/applicant");
        } else {
          // User is signed in but email is not verified
          setIsThirdStep(true);
        }
      }
    });

    return () => unsubscribe();
  }, [dispatch, navigate]);

  // Pass down the `isThirdStep` state to the children components
  return <>{children({ isThirdStep })}</>;
};

export default AuthHandler;
